import React from 'react';
import { graphql } from 'gatsby';
import CompatibilidadeAmorosaBlock from '../components/compatibilidade-amorosa-block'
import Layout from "../components/layout"
import SEO from '../components/seo';
import BreadcrumbJsonLd from '../components/breadcrumb-jsonld';
import {
  Section,
  Content,
} from "bloomer"  

// og:image de la pareja: /astrologia/compatibilidade-amorosa/<a>/<b>/ -> /og/compat-<a>-<b>.png
const ogCompat = slug => {
  const m = /compatibilidade-amorosa\/([a-z]+)\/([a-z]+)\/?$/.exec(slug || "")
  return m ? `/og/compat-${m[1]}-${m[2]}.png` : undefined
}

export default ({ data }) => {
  //const post = data.markdownRemark;
  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html } = markdownRemark
  return (
    <Layout>
      <SEO
        title={`${frontmatter.title} combinam no amor? Compatibilidade dos signos | EstrelaGuia`}
        description={`${frontmatter.title}: descubra a compatibilidade amorosa desses dois signos — os pontos fortes, os desafios e o que os astros dizem sobre essa relação.`}
        pathname={markdownRemark.fields.slug}
        image={ogCompat(markdownRemark.fields.slug)}
      />
      <BreadcrumbJsonLd trail={[
        { name: "Início", path: "/" },
        { name: "Compatibilidade Amorosa", path: "/astrologia/compatibilidade-amorosa/" },
        { name: frontmatter.title, path: markdownRemark.fields.slug },
      ]} />
      <Content>
        <article>
          <header className="content">    
            <h1>{frontmatter.title}</h1>
          </header>
          <Content dangerouslySetInnerHTML={{ __html: html }}/>
          </article>
          {/* <CompatibilidadeAmorosaBlock /> */}

      </Content>
      <Content>
        <h2>Compatibilidade Amorosa</h2>
        <p>Seu amor estava escrito nas estrelas ou é um verdadeiro desastre astral? Descubra o que os astros têm a dizer sobre seu relacionamento amoroso. Selecione o seu signo e depois o do seu par: a combinação aparece na hora. Saiba quais são os pontos fortes e os fracos dessa relação e faça com que dê certo.</p>
        <p>Descubra o que os astros têm a dizer sobre seu relacionamento!</p>
      </Content>
      <CompatibilidadeAmorosaBlock />
    </Layout> 
  );

};

export const query = graphql`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      fields {
        slug
      }
      frontmatter {
        title
        mname
      }
      html
    }
  }
`;